import { render } from "./pop-up-change-email.vue?vue&type=template&id=bf362234&scoped=true"
import script from "./pop-up-change-email.vue?vue&type=script&lang=js"
export * from "./pop-up-change-email.vue?vue&type=script&lang=js"

import "./pop-up-change-email.vue?vue&type=style&index=0&id=bf362234&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf362234"]])

export default __exports__